const STATUS_RANK = {
  overdue: 3,
  'pill-overdue': 3,
  active: 2,
  'pill-active': 2,
  done: 1,
  'pill-done': 1,
  draft: 0,
  'pill-draft': 0,
}

export function compactStageType (value) {
  const text = String(value || '').trim()
  if (!text) return ''
  const [firstPart] = text.split('_')
  return String(firstPart || text).trim() || text
}

export function inferStageTypeFromStageId (stageId, contractNumber = '') {
  let name = String(stageId || '').trim()
  const contract = String(contractNumber || '').trim()

  if (contract) {
    for (const separator of [' — ', ' - ', ' – ']) {
      const prefix = `${contract}${separator}`
      if (name.startsWith(prefix)) {
        name = name.slice(prefix.length).trim()
        break
      }
    }
  }

  const [firstWord] = name.split(/\s+/)
  return compactStageType(firstWord) || compactStageType(name)
}

export function getEmployeeStageTypeKey (stage) {
  const explicit = compactStageType(stage?.тип_стадии || stage?.stage_type || stage?.distribution_type)
  if (explicit) return explicit
  return inferStageTypeFromStageId(
    stage?.id_стадии || stage?.stage_id,
    stage?.номер_договора || stage?.contract_number,
  ) || 'Без типа'
}

export function getDepartmentObjectStageKey (row) {
  const objectStage = String(row?.objectStageName || '').trim()
  if (objectStage) return objectStage
  const stageType = String(row?.stageType || '').trim()
  if (stageType) {
    const [firstWord] = stageType.split(/\s+/)
    return firstWord || stageType
  }
  return 'Без этапа'
}

export function getBudgetCardPath (item) {
  const objectStageId = String(item?.objectStageId || item?.object_stage_id || '').trim()
  if (!objectStageId) return null
  return `/company/budgets/${encodeURIComponent(objectStageId)}`
}

export function getSharedBudgetCardPath (items = [], getItem = (item) => item) {
  const paths = items
    .map((item) => getBudgetCardPath(getItem(item)))
    .filter(Boolean)
  if (!paths.length) return null
  const unique = new Set(paths)
  if (unique.size !== 1) return null
  return paths[0]
}

export function groupItemsByObjectAndType (items, getObjectKey, getTypeKey) {
  const objectGroups = new Map()

  items.forEach((item) => {
    const objectKey = getObjectKey(item)
    const typeKey = getTypeKey(item)
    if (!objectGroups.has(objectKey)) {
      objectGroups.set(objectKey, {
        objectKey,
        types: new Map(),
      })
    }
    const objectGroup = objectGroups.get(objectKey)
    if (!objectGroup.types.has(typeKey)) {
      objectGroup.types.set(typeKey, [])
    }
    objectGroup.types.get(typeKey).push(item)
  })

  return [...objectGroups.values()].map((group) => ({
    ...group,
    types: [...group.types.entries()]
      .sort(([a], [b]) => a.localeCompare(b, 'ru', { numeric: true, sensitivity: 'base' }))
      .map(([typeKey, typeItems]) => ({
        typeKey,
        items: typeItems,
      })),
    itemCount: [...group.types.values()].reduce((sum, list) => sum + list.length, 0),
  }))
}

export function pickRepresentativeItem (items, getRank) {
  if (!items.length) return null
  return items.reduce((best, item) => {
    const bestRank = getRank(best)
    const itemRank = getRank(item)
    return itemRank > bestRank ? item : best
  }, items[0])
}

export function getStatusRank (statusTone) {
  return STATUS_RANK[statusTone] ?? 0
}

export function pluralizeStageBudgets (count) {
  const n = Math.abs(Number(count) || 0) % 100
  const n1 = n % 10
  if (n > 10 && n < 20) return 'бюджетов'
  if (n1 > 1 && n1 < 5) return 'бюджета'
  if (n1 === 1) return 'бюджет'
  return 'бюджетов'
}

export function getContractShortLabel (value) {
  const text = String(value || '').trim()
  if (!text) return '—'
  return text.split(/ - | — | – /)[0].trim() || text
}
